import {
    trigger,
    transition,
    style,
    animate,
    keyframes,
    query,
} from "@angular/animations";

export const fadeAnimation = trigger("fadeAnimation", [
    transition(":enter", [
        style({ opacity: 0 }),
        animate("0.7s ease-out", style({ opacity: 1 })),
    ]),
    transition(":leave", [
        style({ opacity: 1 }),
        animate("0.7s ease-in", style({ opacity: 0 })),
    ]),
]);

export const fadePulseAnimation = trigger("fadePulseAnimation", [
    transition(":enter", [
        style({ opacity: 0, transform: "scale(0.5)" }),
        animate("0.7s ease-out", style({ opacity: 1, transform: "scale(1)" })),
    ]),
    transition(":leave", [
        animate(
            "0.7s ease-in",
            keyframes([
                style({ opacity: 1, transform: "scale(1)" }),
                style({ opacity: 0, transform: "scale(0.5)" }),
            ])
        ),
    ]),
]);

export const slideAnimation = trigger("slideAnimation", [
    transition(":enter", [
        style({ transform: "translateX(-100%)" }),
        animate("0.5s ease-out", style({ transform: "translateX(0)" })),
    ]),
    transition(":leave", [
        animate(
            "0.5s ease-in",
            keyframes([
                style({ transform: "translateX(0)", offset: 0 }),
                style({ transform: "translateX(100%)", offset: 1 }),
            ])
        ),
    ]),
]);

export const slideAnimationRoute = trigger("routeAnimations", [
    transition("* <=> *", [
        style({ position: "relative" }),
        query(":enter, :leave", [
            style({
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
            }),
        ]),
        query(":enter", [style({ left: "-100%" })]),
        query(":leave", [
            style({ left: "0%" }),
            animate("600ms ease", style({ left: "100%" })),
        ]),
        query(":enter", [
            style({ left: "-100%" }),
            animate("600ms ease", style({ left: "0%" })),
        ]),
    ]),
]);
